import React from 'react';
import PropTypes from 'prop-types';
import { Range, getTrackBackground } from 'react-range';
import styles from './RangeSlider.module.scss';

const RangeSlider = ({ disabled, min, max, step, labels, values, unit, onChange, onFinalChange }) => {
  const valueLabels = labels.length > 0 ? labels : values;

  return (
    <div className={styles.wrapper}>
      <div className={styles.slider}>
        <Range
          disabled={disabled}
          step={step}
          min={min}
          max={max}
          values={values}
          onChange={onChange}
          onFinalChange={onFinalChange}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: 2,
                width: '100%',
                cursor: 'pointer',
                background: getTrackBackground({
                  values,
                  colors: values.length === 2 ? ['#ced4da', '#1e83ef', '#ced4da'] : ['#1e83ef', '#ced4da'],
                  min,
                  max
                })
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props: { key, ...thumbProps } }) => (
            <div
              key={key}
              {...thumbProps}
              style={{
                ...thumbProps.style,
                height: 18,
                width: 18,
                borderRadius: '50%',
                outline: 'none',
                backgroundColor: disabled ? '#ededed' : '#1e83ef'
              }}
            />
          )}
        />
      </div>
      <div className={styles.rangeLabels}>
        <div className={styles.leftValue}>{valueLabels[0]}{unit}</div>
        <div className={styles.rightValue}>{valueLabels[1] || max}{unit}</div>
      </div>
    </div>
  );
};

RangeSlider.propTypes = {
  disabled: PropTypes.bool,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  unit: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFinalChange: PropTypes.func
};

RangeSlider.defaultProps = {
  disabled: false,
  step: 1,
  labels: [],
  unit: null,
  onFinalChange() {}
};

export default RangeSlider;
